import React from "react";
import { Link } from "react-router-dom";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Grid,
    Tooltip,
    Typography,
} from "@mui/material";

import ListItemMenu from "../../../Common/ListItemMenu";

import PORTAvatar from "../PORTAvatar";
import RenderDate from "../../../Common/Date/RenderDate";

function QualificationCard({ qualification, onEdit, onDelete }) {
    const dateAchieved = !!qualification?.dateAchieved ? (
        <RenderDate date={qualification.dateAchieved} />
    ) : (
        "Not specified"
    );

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={
                    <Link to={`/portfolio/qualifications/${qualification.id}`}>
                        <Tooltip title="View qualification" arrow>
                            <PORTAvatar
                                type={"qualification"}
                                badge={qualification.isPrimary ? "checked" : ""}
                            />
                        </Tooltip>
                    </Link>
                }
                action={
                    <ListItemMenu
                        onEdit={!!qualification.canUpdate && onEdit}
                        onDelete={!!qualification.canDelete && onDelete}
                    />
                }
                title={
                    <Typography component="h2" className="card-header-title">
                        {qualification.title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {dateAchieved}
                    </Typography>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={12} md={6}>
                            <Typography variant="body2">
                                <strong>Achieved</strong>&nbsp;{dateAchieved}
                            </Typography>
                            <Typography variant="body2">
                                <strong>Country</strong>&nbsp;
                                {!!qualification?.country?.name
                                    ? qualification.country.name
                                    : "Not Specified"}
                            </Typography>
                        </Grid>
                        {!!qualification?.isPrimary && (
                            <Grid item xs={12} sm={12} md={6}>
                                <Typography variant="body2">
                                    <em>Primary qualification</em>
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </Box>

                {!!qualification?.notes && (
                    <Box className="card-content">
                        <Typography variant="body1">
                            {qualification.notes}
                        </Typography>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}

export default QualificationCard;
